import React from "react";
import DataTable from "../../Table/DataTable";
import { useDispatch, useSelector } from "react-redux";
import { useProspectData } from "../../../hooks/useProspectData";
import { elements } from "./data";
import moment from "moment";
import { useTranslation } from "react-i18next";
import VerticalPoints from "../../Common/VerticalPoints/VerticalPoints";
import { openRightModal } from "../../../REDUX/actions/rightModal";
import NewProspectModal from "../NewProspect/NewProspectModal";
import { openCenteredModal } from "../../../REDUX/actions/centeredModal";
import { deleteProspect } from "../../../REDUX/actions/prospects";
import ConfirmModal from "../../Common/Modal/ConfirmModal";
import { useNavigate } from "react-router-dom";

const ProspectTable = () => {
  const { t } = useTranslation("common");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user } = useSelector((state) => state.userReducer);
  const userRole = user?.attributes?.userRole;
  const isAdmin = userRole === 1;

  const {
    fetchData,
    prospects,
    loading,
    pageCount,
    setFilters,
    filters,
    selectOptions,
  } = useProspectData();

  const headers = [
    "Stores",
    "Area",
    "Potentiel Spa/year",
    "Note",
    "Status",
    "Last Action",
    "Reminder date",
  ];

  const AREA_STATUS = {
    AVAILABLE: {
      label: "Available",
      value: "bg-green-600",
    },
    TO_SEIZE: {
      label: "To be seized",
      value: "bg-orange-500",
    },
    TAKEN: {
      label: "Taken",
      value: "bg-red-600",
    },
  };

  const columns = [
    {
      name: "Stores",
      render: (row) => row?.attributes?.companyName ?? "-",
    },
    {
      name: "Area",
      render: (row) => {
        const value = AREA_STATUS[row?.attributes?.areaStatus]?.value;
        return <div className={`${value} br30 w-100 h-20px`}></div>;
      },
    },
    {
      name: "Potentiel Spa/year",
      render: (row) => row?.attributes?.annualSpaPotential ?? "-",
    },
    {
      name: "Note",
      render: (row) => {
        const globalNote = row?.attributes?.note?.data?.attributes?.globalNote;

        return !isNaN(globalNote) && globalNote !== null
          ? `${globalNote.toString().padStart(2, "0")}/20`
          : "-";
      },
    },
    {
      name: "Status",
      render: (row) =>
        row?.attributes?.status ? t(`${row?.attributes?.status}`) : "-",
    },
    {
      name: "Last action",
      render: (row) => {
        const lastAction = row?.attributes?.actions?.data?.find(
          (action) => !action?.attributes?.isReminder
        )?.attributes;
        const interlocutor = lastAction?.interlocutor?.data?.attributes;
        const fullName = [interlocutor?.firstName, interlocutor?.lastName]
          .join(" ")
          ?.trim();

        return (
          <div className="d-flex flex-column gap-1">
            <span>
              {lastAction?.date
                ? `${moment(lastAction?.date).format("DD/MM/YYYY")} - `
                : ""}
              {t(`${lastAction?.type ?? ""}`)}
            </span>
            <span>
              {interlocutor?.occupation ? `${interlocutor?.occupation} - ` : ""}
              {fullName}
            </span>
          </div>
        );
      },
    },
    {
      name: "Reminder date",
      render: (row) => {
        const action = row?.attributes?.actions?.data?.find(
          (action) => action?.attributes?.isReminder
        );

        return action?.attributes?.date
          ? moment(action?.attributes?.date).format("DD/MM/YYYY")
          : "-";
      },
    },
  ];

  if (isAdmin) {
    headers.push("Manager");
    columns.push({
      name: "Manager",
      render: (row) => {
        const name =
          row?.attributes?.business_affiliate?.data?.attributes?.company;
        return name ?? "-";
      },
    });
  }

  headers.push("");
  columns.push({
    name: "options",
    render: (row) => {
      return (
        <VerticalPoints
          showLeft
          options={[
            {
              text: t("View profiles"),
              callback: () => navigate(`/prospects/${row.id}/profils`),
            },
            {
              text: t("Edit"),
              callback: () => {
                dispatch(openRightModal(<NewProspectModal id={row.id} />));
              },
            },
            {
              text: t("Delete"),
              callback: () =>
                dispatch(
                  openCenteredModal(
                    <ConfirmModal
                      id={row?.id}
                      label={t("Prospect")}
                      onConfirm={() => dispatch(deleteProspect(row?.id, t))}
                    />
                  )
                ),
            },
          ]}
        />
      );
    },
  });

  return (
    <div>
      <DataTable
        title={t("Prospect Stores")}
        headers={headers}
        columns={columns}
        fetchData={fetchData}
        totalPages={pageCount}
        data={prospects}
        loading={loading}
        filterElements={elements}
        selectOptions={selectOptions}
        filters={filters}
        noResultsMessage="No results found"
        addNewItem={() => dispatch(openRightModal(<NewProspectModal />))}
        setFilters={setFilters}
      />
    </div>
  );
};

export default ProspectTable;
